import interactionVisibilityActions from '../actions/InteractionVisibilityActions';
import interactionVisibilityService from '../services/questionView/InteractionVisibilityService';

const interactionVisibilityValue = interactionVisibilityService.visibilityValues;

function setTransactionDone(state, questionId) {
    if (!state[questionId]) {
        return state;
    }
    const visibilityTransactionObject = Object.assign({}, state[questionId], {
        transactionDone: true,
    });
    return Object.assign({}, state, {
        [questionId]: visibilityTransactionObject,
    });
}

function setShowInteractions(state, questionId) {
    if (!state[questionId]) {
        return state;
    }
    const visibilityTransactionObject = Object.assign({}, state[questionId], {
        showInteractions: true,
    });
    return Object.assign({}, state, {
        [questionId]: visibilityTransactionObject,
    });
}

export default function (state = {}, action) {
    switch (action.type) {
    case interactionVisibilityActions.types.INTERACTION_VISIBILITY_HIDE_INTERACTIONS:
        return Object.assign({}, state, {
            [action.questionId]: {
                autoPlayAudio: action.interactionVisibility === interactionVisibilityValue.WHEN_COMPLETED_AUTOPLAY,
                mediaLogicalName: action.mediaLogicalName,
                showInteractions: false,
                transactionDone: false,
            },
        });

    case interactionVisibilityActions.types.INTERACTION_VISIBILITY_TRANSACTION_DONE:
        return setTransactionDone(state, action.questionId);

    case interactionVisibilityActions.types.INTERACTION_VISIBILITY_SHOW_INTERACTIONS:
        return setShowInteractions(state, action.questionId);

    default:
        return state;
    }
}
